import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import { objectToFormData } from "../../utils";
import { sagaFunctions } from "../../utils";
import {
  Reports,
  ReportsReject,
  TransactionsReject,
  TransactionsPartialApprove,
  ReportsApprove,
  ReportsExpDetails,
  ReportsExpComments,
  ReportsExpAddComments,
  ReportsComments,
  ReportsCommentsAdd,
  ReportsExportExcel,
  ReportsHistory,
  ReportsAdvance,
  ReportsTrips,
  ReportsExpHistory,
  ReportsReimburse,
  UserReports,
  UserReportSubmit,
  UserReportRecall,
  AddUserReports,
  UserReportFields,
  UserReportLinkExp,
  UserReportLinkAdv,
  ReportsBulkApproveReject,
  ReportDetailsPDF,
  ReportsCount,
  UserReport,
} from "./reports";
import { head } from "lodash";

function getReports(req) {
  return sagaFunctions(Reports, "get", apis.reports, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getUserReport(req) {
  return sagaFunctions(
    UserReport,
    "get",
    req.payload.is_admin ? apis.showReport : apis.userShowReport,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getReportsCount(req) {
  return sagaFunctions(ReportsCount, "get", apis.report_counts, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getReportsReject(req) {
  const isDelete = req.payload.isDelete;
  delete req.payload.isDelete;
  let url = `/api/reports/v1/delete`;
  return sagaFunctions(
    ReportsReject,
    "post",
    isDelete ? url : apis.reportsReject,
    isDelete ? objectToFormData(req.payload) : req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getTransactionsReject(req) {
  return sagaFunctions(
    TransactionsReject,
    "post",
    apis.transactionsReject,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getTransactionsPartialApprove(req) {
  return sagaFunctions(
    TransactionsPartialApprove,
    "post",
    apis.transactionsPartialApprove,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getReportsApprove(req) {
  return sagaFunctions(
    ReportsApprove,
    "post",
    apis.reportsApprove,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function reportDetailsPDF(req) {
  return sagaFunctions(
    ReportDetailsPDF,
    "get",
    apis.reportDetailsPDF,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function reportsBulkApproveReject(req) {
  let type = req.payload.type;
  delete req.payload.type;
  return sagaFunctions(
    ReportsBulkApproveReject,
    "post",
    type === "approve" ? apis.reportsApproveBulk : apis.reportsRejectBulk,
    req.payload,
    {
      "Content-Type": "application/json; charset=utf-8",
    },
  )();
}

function getReportsExpDetails(req) {
  return sagaFunctions(
    ReportsExpDetails,
    "get",
    req.otherParams?.is_admin
      ? apis.getReportTransactionField
      : apis.userTransactions,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

export function* getReportsExpComments(req) {
  let res = null;
  try {
    res = yield call(
      endpoint.get,
      req.otherParams?.is_admin
        ? apis.getReportTransactionComments
        : apis.getUserTransactionComments,
      {
        params: req.payload,
        skipSuccessMessage: true,
      },
    );

    if (res.status < 400) {
      yield put({
        type: ReportsExpComments.SUCCESS,
        payload: { [req.payload?.transaction_id]: res.data },
      });
    } else {
      yield put({
        type: ReportsExpComments.FAILED,
        payload: { [req.payload?.transaction_id]: res.data },
      });
    }
  } catch (err) {
    yield put({
      type: ReportsExpComments.FAILED,
      payload: err?.response?.data,
    });
  }
}

function getReportsExpAddComments(req) {
  return sagaFunctions(
    ReportsExpAddComments,
    "post",
    req.otherParams?.is_admin
      ? apis.getReportTransactionComments
      : apis.getUserTransactionComments,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getReportsComments(req) {
  return sagaFunctions(
    ReportsComments,
    "get",
    req.otherParams?.is_admin ? apis.reportsComments : apis.userReportsComments,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getReportsCommentsAdd(req) {
  let is_admin = req.payload?.is_admin;
  delete req.payload?.is_admin;
  return sagaFunctions(
    ReportsCommentsAdd,
    "post",
    is_admin ? apis.reportsComments : apis.userReportsComments,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getReportsExportExcel(req) {
  return sagaFunctions(
    ReportsExportExcel,
    "post",
    req.otherParams?.is_admin
      ? apis.reportsExportExcel
      : apis.userReportsExportExcel,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getReportsHistory(req) {
  return sagaFunctions(
    ReportsHistory,
    "get",
    req.otherParams?.is_admin ? apis.reportsHistory : apis.userReportsHistory,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getReportsAdvance(req) {
  return sagaFunctions(
    ReportsAdvance,
    "get",
    req.otherParams?.is_admin ? apis.reportsAdvance : apis.userReportsAdvance,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getReportsTrips(req) {
  return sagaFunctions(
    ReportsTrips,
    "get",
    req.otherParams?.is_admin ? apis.trips : apis.userTrips,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getReportsExpHistory(req) {
  return sagaFunctions(
    ReportsExpHistory,
    "get",
    req.otherParams?.is_admin
      ? apis.transactionsHistory
      : apis.userTransactionsHistory,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getReportsReimburse(req) {
  return sagaFunctions(
    ReportsReimburse,
    "post",
    apis.reportsReimburse,
    req.payload,
    {
      "Content-Type": "application/json;charset=UTF-8",
    },
  )();
}

function getUserReports(req) {
  return sagaFunctions(UserReports, "get", apis.userReports, req.payload, {
    headers: {
      "Content-Type": "multipart/formdata",
    },
    skipSuccessMessage: true,
  })();
}

function getUserReportSubmit(req) {
  return sagaFunctions(
    UserReportSubmit,
    "post",
    apis.userReportSubmit,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getUserReportRecall(req) {
  return sagaFunctions(
    UserReportRecall,
    "post",
    apis.userReportRecall,
    req.payload,
  )();
}

function getAddUserReports(req) {
  // let formData = new FormData()
  // req.payload?.field_values?.forEach((ele, i) => {
  //   formData.append(`field_values[${i}][id]`, ele.id)
  //   formData.append(`field_values[${i}][value]`, ele.value)
  // });

  return sagaFunctions(
    AddUserReports,
    "post",
    req.payload?.id
      ? apis.updateUserReport + "?id=" + req.payload.id
      : apis.userReports,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getUserReportFields(req) {
  return sagaFunctions(
    UserReportFields,
    "get",
    apis.userReportFields,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getUserReportLinkExp(req) {
  return sagaFunctions(
    UserReportLinkExp,
    "post",
    apis.userReportLinkExp,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getUserReportLinkAdv(req) {
  return sagaFunctions(
    UserReportLinkAdv,
    "post",
    apis.userReportLinkAdv,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

export function* reportsWatcher() {
  yield takeLatest(Reports.REQUEST, getReports);
  yield takeLatest(UserReport.REQUEST, getUserReport);
  yield takeLatest(ReportsCount.REQUEST, getReportsCount);
  yield takeLatest(ReportsReject.REQUEST, getReportsReject);
  yield takeLatest(ReportsBulkApproveReject.REQUEST, reportsBulkApproveReject);
  yield takeLatest(TransactionsReject.REQUEST, getTransactionsReject);
  yield takeLatest(
    TransactionsPartialApprove.REQUEST,
    getTransactionsPartialApprove,
  );
  yield takeLatest(ReportsApprove.REQUEST, getReportsApprove);
  yield takeLatest(ReportsExpDetails.REQUEST, getReportsExpDetails);
  yield takeEvery(ReportsExpComments.REQUEST, getReportsExpComments);
  yield takeLatest(ReportsExpAddComments.REQUEST, getReportsExpAddComments);
  yield takeLatest(ReportsComments.REQUEST, getReportsComments);
  yield takeLatest(ReportsCommentsAdd.REQUEST, getReportsCommentsAdd);
  yield takeLatest(ReportsExportExcel.REQUEST, getReportsExportExcel);
  yield takeLatest(ReportsHistory.REQUEST, getReportsHistory);
  yield takeLatest(ReportsAdvance.REQUEST, getReportsAdvance);
  yield takeLatest(ReportsTrips.REQUEST, getReportsTrips);
  yield takeLatest(ReportsExpHistory.REQUEST, getReportsExpHistory);
  yield takeLatest(ReportsReimburse.REQUEST, getReportsReimburse);

  yield takeLatest(UserReports.REQUEST, getUserReports);
  yield takeLatest(UserReportSubmit.REQUEST, getUserReportSubmit);
  yield takeLatest(UserReportRecall.REQUEST, getUserReportRecall);
  yield takeLatest(AddUserReports.REQUEST, getAddUserReports);
  yield takeLatest(UserReportFields.REQUEST, getUserReportFields);
  yield takeLatest(UserReportLinkExp.REQUEST, getUserReportLinkExp);
  yield takeLatest(UserReportLinkAdv.REQUEST, getUserReportLinkAdv);
  yield takeLatest(ReportDetailsPDF.REQUEST, reportDetailsPDF);
}
